export default __webpack_public_path__ + "static/media/backoffice-invoices.0e47cf8b.webp";